import meta from './meta.js';
import Server from './server.js';

function base() {
    return meta.value("bonprix:baseUrl");
}

function serverDomain() {
    const protocol = Server.protocol();
    return `${protocol}//${host()}`;
}

function host() {
    const hostname = Server.hostname();
    const port = Server.port();
    const prefixedPort = port ? `:${port}` : '';

    return `${hostname}${prefixedPort}`
}

function toAbsolute(relativeUrl) {
    if(base().endsWith("/") && relativeUrl.startsWith("/")) {
        relativeUrl = relativeUrl.substring(1);
    }
    let outputUrlEnd = relativeUrl;
    if(base().endsWith("/") && relativeUrl.startsWith("/")) {
        outputUrlEnd = outputUrlEnd.substring(1);
    }
    return `${serverDomain()}${base()}${outputUrlEnd}`;
}

function addUrlParam(url, key, value) {
    let urlWithParam = url;
    if(!key) {
        return urlWithParam;
    }

    if(urlWithParam.indexOf("?") !== -1) {
        urlWithParam += "&";
    } else {
        urlWithParam += "?";
    }

    if(!value) {
        urlWithParam += `${key}`;
        return urlWithParam;
    }

    urlWithParam += `${key}=${value}`;

    return urlWithParam;
}

function createUrlParamBuilder(url) {
    const builder = {url: url};
    builder.param = (key, value) => {
        builder.url = addUrlParam(builder.url, key, value);
        return builder;
    };
    builder.build = () => builder.url;
    return builder;
}

function toStaticResourcesRoot(path) {
    return meta.value("bonprix:staticResourcesRoot") + path;
}

export default {
    toAbsolute,
    base,
    host,
    createUrlParamBuilder,
    addUrlParam,
    serverDomain,
    toStaticResourcesRoot
};
